import React, { useState, useEffect } from 'react';
import usflag from '../../assets/images/usflag.png';

const NotificationCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [isDropping, setIsDropping] = useState(false);

  // Random women names
  const womenNames = [
    'Emma', 'Olivia', 'Ava', 'Isabella', 'Sophia', 'Charlotte', 'Mia', 'Amelia',
    'Harper', 'Evelyn', 'Abigail', 'Emily', 'Elizabeth', 'Mila', 'Ella', 'Avery',
    'Sofia', 'Camila', 'Aria', 'Scarlett', 'Victoria', 'Madison', 'Luna', 'Grace',
    'Chloe', 'Penelope', 'Layla', 'Riley', 'Zoey', 'Nora', 'Lily', 'Eleanor',
    'Hannah', 'Lillian', 'Addison', 'Aubrey', 'Ellie', 'Stella', 'Natalie', 'Zoe'
  ];

  // Seasonal analysis values
  const seasonalValues = [
    'Warm Neutral',
    'Cool Neutral',
    'Warm Deep',
    'Cool Deep',
    'Warm Light',
    'Cool Light',
    'Soft Warm',
    'Soft Cool',
    'Rich Warm',
    'Rich Cool'
  ];

  // Generate 20 different notifications
  const generateNotifications = () => {
    const notifications = [];
    for (let i = 0; i < 20; i++) {
      const randomName = womenNames[Math.floor(Math.random() * womenNames.length)];
      const randomSeason = seasonalValues[Math.floor(Math.random() * seasonalValues.length)];
      
      notifications.push({
        id: i,
        name: randomName,
        season: randomSeason
      });
    }
    return notifications;
  };

  const [notifications] = useState(generateNotifications());

  useEffect(() => {
    const intervalId = setInterval(() => {
      // Trigger slide-up animation
      setIsVisible(false);
      
      // After slide-up, change notification
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % notifications.length);
        setIsDropping(true);
        setIsVisible(true);
        
        // Reset dropping state
        setTimeout(() => {
          setIsDropping(false);
        }, 500);
      }, 300);
    }, 5000);

    // Cleanup
    return () => {
      clearInterval(intervalId);
    };
  }, [notifications.length]);

  const currentNotification = notifications[currentIndex];

  return (
    <div className="py-2 w-full overflow-hidden">
      <div className="flex items-center justify-center">
        <div 
          className={`flex items-center transition-all duration-500 ease-in-out ${
            isVisible 
              ? isDropping 
                ? 'opacity-100 transform translate-y-0 animate-bounce' 
                : 'opacity-100 transform translate-y-0'
              : 'opacity-0 transform -translate-y-4'
          }`}
        >
          <div className="flex items-center whitespace-nowrap font-[var(--funnel-cs-font-body)] text-xs text-[var(--funnel-cs-text)]">
            <span className="font-semibold text-[var(--funnel-cs-accent)]">{currentNotification.name}</span>
            <span className="mx-1 text-[var(--funnel-cs-text)]">Just Bought her Analysis!</span>
            <img 
              src={usflag} 
              alt="US Flag" 
              className="w-4 h-3 mx-1 rounded-sm object-cover shadow-sm"
            />
            <span className="mr-1 text-[var(--funnel-cs-text)]">She is</span>
            <span className="rounded border border-[var(--funnel-cs-accent-border)] bg-[var(--funnel-cs-accent-soft)] px-1 py-0.5 text-xs font-bold text-[var(--funnel-cs-accent)]">{currentNotification.season}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationCarousel;
